import styled from 'styled-components'

interface IDiv {
  margin?: string
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  max-width: 1200px;
  padding: 3.5%;
`

export const TopButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0px;
`

export const InfoUserContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: stretch;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
`

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 43%;
  height: 100%;
  border-radius: 10px;
`

export const CardInfo = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: white;
  flex-direction: column;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  width: 100%;
  margin: 20px 0px;
  padding: 20px;
`

export const SkillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
`

export const ReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: auto;
  height: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 3% 0% 3% 3%;
`

export const ChartContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

export const SubContainerChart = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const RowContainer = styled.div<IDiv>`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 20px;
  margin: ${(props) => props.margin};
  gap: 20px;
`

export const BetesaMeasurementCard = styled.div<{ $isFollowUp?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding-left: ${(props) => (props.$isFollowUp ? '14px' : '10px')};
  border-left: ${(props) => (props.$isFollowUp ? '3px solid #2D749C' : '3px solid #C6016B')};

  ${(props) =>
    props.$isFollowUp &&
    `
      & > div {
        width: 290px;
        height: 108px;
      }

      & > div > div:first-child {
        width: 90px;
      }

      & > div h3 {
        font-size: 16px;
      }
    `}
`

export const BetesaMeasurementLabel = styled.span<{ $isFollowUp?: boolean }>`
  align-self: flex-start;
  color: ${(props) => (props.$isFollowUp ? '#2D749C' : '#C6016B')};
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
`

export const BetesaGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
`

export const BetesaFollowUpList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-left: 18px;
  padding-left: 14px;
  border-left: 2px solid #b7d2e0;
`

export const MeasurementMeta = styled.small`
  color: #526570;
  font-size: 0.75rem;
  line-height: 1.5;
`
